import React from 'react';
import type Trip from '@this/domain/trip/trip2';
import OrderItemDescription from './order_item_description';
import { type ItemPriceProps, SectionDesc } from './shared';

interface OrderItemsDescriptionProps {
  trip: Trip;
  transportVacancies: {
    transportId: number;
    priceDiff: number;
    occupied: boolean;
  }[];
}

const OrderItemsDescription: React.FC<OrderItemsDescriptionProps> = ({ trip, transportVacancies }) => {
  return trip.order ? (
    <>
      {trip.order.orderItems.map(orderItem => {
        const transportVacancy = transportVacancies.find(tv => tv.transportId === orderItem.transports[0]?.id);

        let ticketStateType: ItemPriceProps['ticketStateType'] = 'notApplicable';
        let changedPrice = orderItem.price.price;
        if (transportVacancy) {
          if (transportVacancy.occupied) {
            ticketStateType = 'noFlight';
          } else if (transportVacancy.priceDiff > 0) {
            ticketStateType = 'priceChanged';
            changedPrice += transportVacancy.priceDiff;
          } else {
            ticketStateType = 'priceNotChanged';
          }
        }

        return (
          <SectionDesc key={orderItem.id}>
            <OrderItemDescription
              ticketStateType={ticketStateType}
              trip={trip}
              tripId={trip.id}
              orderItem={orderItem}
              changedPrice={changedPrice}
            />
          </SectionDesc>
        );
      })}
    </>
  ) : null;
};

export default OrderItemsDescription;
export type { OrderItemsDescriptionProps };
